import { all, fork } from "redux-saga/effects";
import { sagaCoordinator } from "./SagaCoordinator";
import { wrapSagaExports } from "./SagaWrappers";
import * as signinSagas from "Components/Signin/Saga/SigninSaga";
import * as registerSagas from "Components/Register/Saga/RegisterSaga";
import * as VerificationCodeSagas from "Components/VerificationCode/Saga/VerificationCodeSaga";
import * as SetPasswordSaga from "Components/SetPassword/Saga/SetPasswordSaga";
import * as GettingStartedSaga from "Components/GettingStarted/Saga/GettingStartedSaga";
import * as GettingStartedBranchSaga from "Components/GettingStarted/Saga/GettingStartedBranchSaga";
import * as GettingStartedResidentSaga from "Components/GettingStarted/Saga/GettingStartedResidentSaga";
import * as existingUserSagas from "Components/Register/Saga/ExistingUserSaga";
import * as countrySaga from "Components/EmploymentAndIncome/Saga/CountrySaga";
import * as statusSaga from "Components/EmploymentAndIncome/Saga/StatusSaga";
import * as GetEmployerPositionSaga from "Components/EmploymentAndIncome/Saga/GetEmployerPositionSaga";
import * as incomeSourcesSaga from "Components/EmploymentAndIncome/Saga/IncomeSourceSaga";
import * as TermsSagas from "Components/TermsAndConditions/Saga/TermsSaga";
import * as TermsJsonSaga from "Components/TermsAndConditions/Saga/TermsJsonSaga";
import * as AccountPurposeSaga from "Components/Compliance/Saga/AccountPurposeSaga";
import * as IndicateWhoSaga from "Components/Compliance/Saga/IndicateWhoSaga";
import * as getIdTypeWatcherSaga from "Components/AboutYou/Saga/GetIdTypeSaga";
import * as instntDocWatcherSaga from "Components/AboutYou/Saga/InstntDocSaga";
import * as submitVerifyWatcherSaga from "Components/AboutYou/Saga/SubmitVerifySaga";
import * as createApplicationWatcherSaga from "Components/AboutYou/Saga/CreateApplicationSaga";
import * as getProvinceListWatcherSaga from "Components/AboutYou/Saga/GetProvinceListSaga";
import * as GetVaultSaga from "Components/AboutYou/Saga/GetVaultSaga";
import * as UpdateVaultSaga from "Components/AboutYou/Saga/UpdateVaultSaga";
import * as GetVaultMemberSaga from "Components/AboutYou/Saga/GetVaultMemberSaga";
import * as UpdateVaultMemberSaga from "Components/AboutYou/Saga/UpdateVaultMemberSaga";
import * as confirmAccountCreateWatcherSaga from "Components/ConfirmAccountCreate/Saga/ConfirmAccountCreateSaga";
import * as ForgotPasswordSagas from "Redux/Sagas/ForgotPasswordSaga";
import * as RecoverPasswordSagas from "Redux/Sagas/RecoverPasswordSaga";
import * as RefreshTokenSaga from "Redux/Sagas/RefreshTokenSaga";
import * as LogoutSaga from "Redux/Sagas/LogoutSaga";
import * as UpdateApplicantSaga from "Redux/Sagas/UpdateApplicantSaga";
import * as UpdateContractSaga from "Redux/Sagas/UpdateContractSaga";
import * as UpdateApplicationSaga from "Redux/Sagas/UpdateApplicationSaga";
import * as FundProcessSaga from "Components/FundingAmount/Saga/FundProcessSaga";
import * as FundPaymentDetailsSaga from "Components/FundingAmount/Saga/FundPaymentDetailsSaga";
import * as GetApplicantSaga from "Redux/Sagas/GetApplicantSaga";
import * as GetContractSaga from "Redux/Sagas/GetContractSaga";
import * as GetGettingStartedSaga from "Redux/Sagas/GetGettingStartedSaga";
import * as GetApplicantListSaga from "Redux/Sagas/GetApplicantListSaga";
import * as GetAccountSaga from "Redux/Sagas/GetAccountSaga";
import * as GetAccountDataSaga from "Redux/Sagas/GetAccountDataSaga";
import * as ProductListSaga from "Components/MarketPlace/Saga/ProductListSaga";
import * as UpdateProductVaultSaga from "Components/MarketPlace/Saga/UpdateProductVaultSaga";
import * as GetProductVaultSaga from "Components/MarketPlace/Saga/GetProductVaultSaga";
import * as CreateInveriteSaga from "Components/Inverite/Saga/CreateInveriteSaga";
import * as FetchInveriteSaga from "Components/Inverite/Saga/FetchInveriteSaga";
import * as CreateInveriteAccountListSaga from "Components/Inverite/Saga/CreateInveriteAccountListSaga";
import * as FetchInveriteAccountListSaga from "Components/Inverite/Saga/FetchInveriteAccountListSaga";
import * as AddApplicantSaga from "Components/Inverite/Saga/AddApplicantSaga";
import * as FindApplicantSaga from "Components/Inverite/Saga/FindApplicantSaga";
import * as DeleteApplicationSaga from "Redux/Sagas/DeleteApplicationSaga";
import * as GetApplicationListSaga from "Redux/Sagas/GetApplicationListSaga";
import * as GetApplicationSaga from "Redux/Sagas/GetApplicationSaga";
import * as ProductTemplateSaga from "Redux/Sagas/ProductTemplateSaga";
import * as UpdateProductInformationSaga from "Redux/Sagas/UpdateProductInformationSaga";
import * as IntendedUseSaga from "Components/AccountInformation/Saga/IntendedUseSaga";
import * as GetProductInformationSaga from "Redux/Sagas/GetProductInformationSaga";
import * as GetBeneficiaryTypeSaga from "Components/Beneficiaries/Saga/GetBeneficiaryTypeSaga";
import * as GetBeneficiaryRelationSaga from "Components/Beneficiaries/Saga/GetBeneficiaryRelationSaga";
import * as AddBeneficiariesSaga from "Components/Beneficiaries/Saga/AddBeneficiariesSaga";
import * as DeleteBeneficiarySaga from "Components/Beneficiaries/Saga/DeleteBeneficiarySaga";
import * as GetBeneficiariesSaga from "Components/Beneficiaries/Saga/GetBeneficiariesSaga";
import * as EditBeneficiariSaga from "Components/Beneficiaries/Saga/EditBeneficiariSaga";
import * as SpousalInfoSaga from "Components/SpousalInfo/Saga/SpousalInfoSaga";
import * as GetSpousalInfoSaga from "Components/SpousalInfo/Saga/GetSpousalInfoSaga";
import * as addApplicationSlotWatcherSaga from "Components/JointApplicant/Saga/AddApplicationSlotSaga";
import * as addJointApplicantsSaga from "Components/JointApplicant/Saga/AddJointApplicantsSaga";
import * as inviteApplicationSlotWatcherSaga from "Components/JointApplicant/Saga/InviteApplicationSaga";
import * as GetApplicantTypeSaga from "Components/JointApplicant/Saga/GetApplicantTypeSaga";
import * as GetApplicationPropertySaga from "Components/JointApplicant/Saga/GetApplicationPropertySaga";
import * as DeleteApplicationSlotSaga from "Components/JointApplicant/Saga/DeleteApplicationSlotSaga";
import * as GetBundleProductRelationSaga from "Redux/Sagas/GetBundleProductRelationSaga";
import * as AddBundleProductSaga from "Components/DebitCard/Saga/AddBundleProductSaga";
import * as DeleteDebitCardSaga from "Components/DebitCard/Saga/DeleteDebitCardSaga";
import * as AddGlobalVaultSaga from "Components/JointApplicant/Saga/AddGlobalVaultSaga";
import * as GetGlobalVaultSaga from "Components/JointApplicant/Saga/GetGlobalVaultSaga";
import * as ApplicantCreateRequestSaga from "Components/JointApplicant/Saga/ApplicantCreateRequestSaga";
import * as ApplicantCreateSelfSaga from "Components/JointApplicant/Saga/ApplicantCreateSelfSaga";
import * as OtpVerifyInviteSaga from "Components/JointApplicant/Saga/OtpVerifyInviteSaga";
import * as EnableOnlineBankingSaga from "Components/OnlineBanking/Saga/EnableOnlineBankingSaga";
import * as UploadOnlineBankingSaga from "Components/OnlineBanking/Saga/UploadOnlineBankingSaga";
import * as GetDebitCardNumberSaga from "Components/OnlineBanking/Saga/GetDebitCardNumberSaga";
import * as FillApplicationSlotSaga from "Components/JointApplicant/Saga/FillApplicationSlotSaga";
import * as CreateEsignDocSaga from "Components/Signature/Saga/CreateEsignDocSaga";
import * as CheckEsignDocSaga from "Components/Signature/Saga/CheckEsignDocSaga";
import * as GetEsignSaga from "Components/Signature/Saga/GetEsignSaga";
import * as SendEsignPackageSaga from "Components/Signature/Saga/SendEsignPackageSaga";
import * as ConfirmApplicantCreateSaga from "Components/JointApplicant/Saga/ConfirmApplicantCreateSaga";
import * as GetLoanProductSaga from "Components/LoanDetails/Saga/GetLoanProductSaga";
import * as AddAssetSaga from "Components/Asset/Saga/AddAssetSaga";
import * as GetAssetSaga from "Components/Asset/Saga/GetAssetSaga";
import * as UpdateAssetSaga from "Components/Asset/Saga/UpdateAssetSaga";
import * as AddVehicleSaga from "Components/Asset/Saga/AddVehicleSaga";
import * as GetVehicleSaga from "Components/Asset/Saga/GetVehicleSaga";
import * as UpdateVehicleSaga from "Components/Asset/Saga/UpdateVehicleSaga";
import * as AddRealEstateSaga from "Components/Asset/Saga/AddRealEstateSaga";
import * as GetRealEstateSaga from "Components/Asset/Saga/GetRealEstateSaga";
import * as UpdateRealEstateSaga from "Components/Asset/Saga/UpdateRealEstateSaga";
import * as AddIncomeSaga from "Components/Income/Saga/AddIncomeSaga";
import * as GetIncomeSaga from "Components/Income/Saga/GetIncomeSaga";
import * as UpdateIncomeSaga from "Components/Income/Saga/UpdateIncomeSaga";
import * as AddExpenseSaga from "Components/Expense/Saga/AddExpenseSaga";
import * as GetExpenseSaga from "Components/Expense/Saga/GetExpenseSaga";
import * as UpdateExpenseSaga from "Components/Expense/Saga/UpdateExpenseSaga";
import * as AddLiabilitiesSaga from "Components/Liabilities/Saga/AddLiabilitiesSaga";
import * as GetLiabilitiesSaga from "Components/Liabilities/Saga/GetLiabilitiesSaga";
import * as UpdateLiabilitiesSaga from "Components/Liabilities/Saga/UpdateLiabilitiesSaga";
import * as UpdateLendingProductSecuritySaga from "Components/LoanDetails/Saga/UpdateLendingProductSecuritySaga";
import * as GetLoanSecuritySaga from "Components/LoanDetails/Saga/GetLoanSecuritySaga";
import * as DeleteFinancialSaga from "Components/LoanDetails/Saga/DeleteFinancialSaga";
import * as DeleteLoanSecuritySaga from "Components/LoanDetails/Saga/DeleteLoanSecuritySaga";
import * as GetFinancialAnalysisListSaga from "Components/LoanDetails/Saga/GetFinancialAnalysisListSaga";
import * as GetFinancialAnalysisFinancialListSaga from "Components/LoanDetails/Saga/GetFinancialAnalysisFinancialListSaga";
import * as GetLendingProductSaga from "Components/LoanDetails/Saga/GetLendingProductSaga";
import * as UpdateLendingProductSaga from "Components/LoanDetails/Saga/UpdateLendingProductSaga";
import * as GetDocumentListSaga from "Components/Documents/Saga/GetDocumentListSaga";
import * as AddDocumentSaga from "Components/Documents/Saga/AddDocumentSaga";
import * as DeleteDocumentSaga from "Components/Documents/Saga/DeleteDocumentSaga";
import * as GetDocumentSaga from "Redux/Sagas/GetDocumentSaga";
import * as FinInfoSaga from "Components/MarketPlace/Saga/FinInfoSaga";
import * as GetBankingProductListSaga from "Components/AccountInformation/Saga/GetBankingProductListSaga";
import * as AddressCorrectionSaga from "Components/AboutYou/Saga/AddressCorrectionSaga";
import * as CreateAddressInstanceKeySaga from "Components/AboutYou/Saga/CreateAddressInstanceKeySaga";
import * as SupportMessage from "Components/MarketPlace/Saga/SupportMessageSaga";
import * as GetOccupationCodes from "Redux/Sagas/GetOccupationCodesSaga";
import * as GetReasonCodes from "Redux/Sagas/GetReasonCodesSaga";
import * as GetTermProductSaga from "Components/GICInfo/Saga/GetTermProductSaga";
import * as UpdateTermProductSaga from "Components/GICInfo/Saga/UpdateTermProductSaga";
import * as GetCentralSaga from "Redux/Sagas/GetCentralSaga";
import * as GetCompleteApplicantSaga from "Redux/Sagas/GetCompleteApplicantSaga";
import * as GetCountriesTaxSaga from "Redux/Sagas/GetCountriesTaxSaga";
import * as SearchEscSaga from "Redux/Sagas/SearchEscSaga";
import * as RequestEscSaga from "Redux/Sagas/RequestEscSaga";
import * as ProfileEscSaga from "Redux/Sagas/ProfileEscSaga";
import * as SubmitQuestionnaireSaga from "Components/Questionnaire/Saga/SubmitQuestionnaireSaga";
import * as UploadQuestionnaireSaga from "Components/Questionnaire/Saga/UploadQuestionnaireSaga";
import * as GetProspectSaga from "Redux/Sagas/GetProspectSaga";
import * as SearchMemberSaga from "Redux/Sagas/SearchMemberSaga";
import * as UpdatePersonalSaga from "Redux/Sagas/UpdatePersonalSaga";
import * as KycInviteSaga from "Redux/Sagas/KycInviteSaga";
import * as AccountSearchSaga from "Redux/Sagas/AccountSearchSaga";
import * as AccountCreateSaga from "Redux/Sagas/AccountCreateSaga";
import * as ApplicationSearchSaga from "Redux/Sagas/ApplicationSearchSaga";
import * as FileListSaga from "Redux/Sagas/FileListSaga";
import * as FileUploadSaga from "Redux/Sagas/FileUploadSaga";
import * as FileManagementSaga from "Redux/Sagas/FileManagementSaga";
import * as GetApplicationNotesSaga from "Redux/Sagas/GetApplicationNotesSaga";
import * as UpdateApplicationNotesReviewSaga from "Redux/Sagas/UpdateApplicationNotesReviewSaga";
import * as GetPaysafeDetailsSaga from "Redux/Sagas/GetPaysafeDetailsSaga";
import * as GetStaffListSaga from "Redux/Sagas/GetStaffListSaga";
export default function* rootSaga() {
  yield all(
    [
      // Start the saga coordinator first
      sagaCoordinator,

      // RefreshTokenSaga runs without coordination (it controls the coordination)
      ...Object.values(RefreshTokenSaga),

      // All other sagas are wrapped with coordination
      ...Object.values(wrapSagaExports(signinSagas)),
      ...Object.values(wrapSagaExports(registerSagas)),
      ...Object.values(wrapSagaExports(existingUserSagas)),
      ...Object.values(wrapSagaExports(VerificationCodeSagas)),
      ...Object.values(wrapSagaExports(ForgotPasswordSagas)),
      ...Object.values(wrapSagaExports(RecoverPasswordSagas)),
      ...Object.values(wrapSagaExports(SetPasswordSaga)),
      ...Object.values(wrapSagaExports(countrySaga)),
      ...Object.values(wrapSagaExports(statusSaga)),
      ...Object.values(wrapSagaExports(incomeSourcesSaga)),
      ...Object.values(wrapSagaExports(TermsSagas)),
      ...Object.values(wrapSagaExports(TermsJsonSaga)),
      ...Object.values(wrapSagaExports(GettingStartedSaga)),
      ...Object.values(wrapSagaExports(GettingStartedBranchSaga)),
      ...Object.values(wrapSagaExports(GettingStartedResidentSaga)),
      ...Object.values(wrapSagaExports(AccountPurposeSaga)),
      ...Object.values(wrapSagaExports(IndicateWhoSaga)),
      ...Object.values(wrapSagaExports(getIdTypeWatcherSaga)),
      ...Object.values(wrapSagaExports(instntDocWatcherSaga)),
      ...Object.values(wrapSagaExports(submitVerifyWatcherSaga)),
      ...Object.values(wrapSagaExports(createApplicationWatcherSaga)),
      ...Object.values(wrapSagaExports(getProvinceListWatcherSaga)),
      ...Object.values(wrapSagaExports(confirmAccountCreateWatcherSaga)),
      ...Object.values(wrapSagaExports(LogoutSaga)),
      ...Object.values(wrapSagaExports(UpdateApplicantSaga)),
      ...Object.values(wrapSagaExports(UpdateContractSaga)),
      ...Object.values(wrapSagaExports(UpdateApplicationSaga)),
      ...Object.values(wrapSagaExports(FundProcessSaga)),
      ...Object.values(wrapSagaExports(FundPaymentDetailsSaga)),
      ...Object.values(wrapSagaExports(GetApplicantSaga)),
      ...Object.values(wrapSagaExports(GetContractSaga)),
      ...Object.values(wrapSagaExports(GetGettingStartedSaga)),
      ...Object.values(wrapSagaExports(GetApplicantListSaga)),
      ...Object.values(wrapSagaExports(GetAccountSaga)),
      ...Object.values(wrapSagaExports(GetAccountDataSaga)),
      ...Object.values(wrapSagaExports(ProductListSaga)),
      ...Object.values(wrapSagaExports(UpdateProductVaultSaga)),
      ...Object.values(wrapSagaExports(GetProductVaultSaga)),
      ...Object.values(wrapSagaExports(CreateInveriteSaga)),
      ...Object.values(wrapSagaExports(FetchInveriteSaga)),
      ...Object.values(wrapSagaExports(CreateInveriteAccountListSaga)),
      ...Object.values(wrapSagaExports(FetchInveriteAccountListSaga)),
      ...Object.values(wrapSagaExports(AddApplicantSaga)),
      ...Object.values(wrapSagaExports(FindApplicantSaga)),
      ...Object.values(wrapSagaExports(DeleteApplicationSaga)),
      ...Object.values(wrapSagaExports(GetApplicationListSaga)),
      ...Object.values(wrapSagaExports(GetApplicationSaga)),
      ...Object.values(wrapSagaExports(ProductTemplateSaga)),
      ...Object.values(wrapSagaExports(UpdateProductInformationSaga)),
      ...Object.values(wrapSagaExports(IntendedUseSaga)),
      ...Object.values(wrapSagaExports(GetProductInformationSaga)),
      ...Object.values(wrapSagaExports(GetBeneficiaryTypeSaga)),
      ...Object.values(wrapSagaExports(GetBeneficiaryRelationSaga)),
      ...Object.values(wrapSagaExports(AddBeneficiariesSaga)),
      ...Object.values(wrapSagaExports(DeleteBeneficiarySaga)),
      ...Object.values(wrapSagaExports(GetBeneficiariesSaga)),
      ...Object.values(wrapSagaExports(EditBeneficiariSaga)),
      ...Object.values(wrapSagaExports(SpousalInfoSaga)),
      ...Object.values(wrapSagaExports(GetSpousalInfoSaga)),
      ...Object.values(wrapSagaExports(addApplicationSlotWatcherSaga)),
      ...Object.values(wrapSagaExports(addJointApplicantsSaga)),
      ...Object.values(wrapSagaExports(inviteApplicationSlotWatcherSaga)),
      ...Object.values(wrapSagaExports(GetApplicantTypeSaga)),
      ...Object.values(wrapSagaExports(GetApplicationPropertySaga)),
      ...Object.values(wrapSagaExports(DeleteApplicationSlotSaga)),
      ...Object.values(wrapSagaExports(GetBundleProductRelationSaga)),
      ...Object.values(wrapSagaExports(AddBundleProductSaga)),
      ...Object.values(wrapSagaExports(DeleteDebitCardSaga)),
      ...Object.values(wrapSagaExports(AddGlobalVaultSaga)),
      ...Object.values(wrapSagaExports(GetGlobalVaultSaga)),
      ...Object.values(wrapSagaExports(ApplicantCreateRequestSaga)),
      ...Object.values(wrapSagaExports(ApplicantCreateSelfSaga)),
      ...Object.values(wrapSagaExports(OtpVerifyInviteSaga)),
      ...Object.values(wrapSagaExports(EnableOnlineBankingSaga)),
      ...Object.values(wrapSagaExports(UploadOnlineBankingSaga)),
      ...Object.values(wrapSagaExports(FillApplicationSlotSaga)),
      ...Object.values(wrapSagaExports(CreateEsignDocSaga)),
      ...Object.values(wrapSagaExports(CheckEsignDocSaga)),
      ...Object.values(wrapSagaExports(GetEsignSaga)),
      ...Object.values(wrapSagaExports(SendEsignPackageSaga)),
      ...Object.values(wrapSagaExports(ConfirmApplicantCreateSaga)),
      ...Object.values(wrapSagaExports(GetLoanProductSaga)),
      ...Object.values(wrapSagaExports(AddAssetSaga)),
      ...Object.values(wrapSagaExports(GetAssetSaga)),
      ...Object.values(wrapSagaExports(UpdateAssetSaga)),
      ...Object.values(wrapSagaExports(AddVehicleSaga)),
      ...Object.values(wrapSagaExports(GetVehicleSaga)),
      ...Object.values(wrapSagaExports(UpdateVehicleSaga)),
      ...Object.values(wrapSagaExports(AddRealEstateSaga)),
      ...Object.values(wrapSagaExports(GetRealEstateSaga)),
      ...Object.values(wrapSagaExports(UpdateRealEstateSaga)),
      ...Object.values(wrapSagaExports(AddIncomeSaga)),
      ...Object.values(wrapSagaExports(GetIncomeSaga)),
      ...Object.values(wrapSagaExports(UpdateIncomeSaga)),
      ...Object.values(wrapSagaExports(AddExpenseSaga)),
      ...Object.values(wrapSagaExports(GetExpenseSaga)),
      ...Object.values(wrapSagaExports(UpdateExpenseSaga)),
      ...Object.values(wrapSagaExports(AddLiabilitiesSaga)),
      ...Object.values(wrapSagaExports(GetLiabilitiesSaga)),
      ...Object.values(wrapSagaExports(UpdateLiabilitiesSaga)),
      ...Object.values(wrapSagaExports(UpdateLendingProductSaga)),
      ...Object.values(wrapSagaExports(GetLoanSecuritySaga)),
      ...Object.values(wrapSagaExports(DeleteFinancialSaga)),
      ...Object.values(wrapSagaExports(DeleteLoanSecuritySaga)),
      ...Object.values(wrapSagaExports(GetFinancialAnalysisListSaga)),
      ...Object.values(wrapSagaExports(GetFinancialAnalysisFinancialListSaga)),
      ...Object.values(wrapSagaExports(GetLendingProductSaga)),
      ...Object.values(wrapSagaExports(UpdateLendingProductSecuritySaga)),
      ...Object.values(wrapSagaExports(GetDocumentListSaga)),
      ...Object.values(wrapSagaExports(AddDocumentSaga)),
      ...Object.values(wrapSagaExports(DeleteDocumentSaga)),
      ...Object.values(wrapSagaExports(GetDocumentSaga)),
      ...Object.values(wrapSagaExports(FinInfoSaga)),
      ...Object.values(wrapSagaExports(GetBankingProductListSaga)),
      ...Object.values(wrapSagaExports(AddressCorrectionSaga)),
      ...Object.values(wrapSagaExports(CreateAddressInstanceKeySaga)),
      ...Object.values(wrapSagaExports(SupportMessage)),
      ...Object.values(wrapSagaExports(GetOccupationCodes)),
      ...Object.values(wrapSagaExports(GetReasonCodes)),
      ...Object.values(wrapSagaExports(GetEmployerPositionSaga)),
      ...Object.values(wrapSagaExports(GetTermProductSaga)),
      ...Object.values(wrapSagaExports(UpdateTermProductSaga)),
      ...Object.values(wrapSagaExports(GetCentralSaga)),
      ...Object.values(wrapSagaExports(GetCountriesTaxSaga)),
      ...Object.values(wrapSagaExports(GetCompleteApplicantSaga)),
      ...Object.values(wrapSagaExports(GetDebitCardNumberSaga)),
      ...Object.values(wrapSagaExports(SearchEscSaga)),
      ...Object.values(wrapSagaExports(RequestEscSaga)),
      ...Object.values(wrapSagaExports(ProfileEscSaga)),
      ...Object.values(wrapSagaExports(SubmitQuestionnaireSaga)),
      ...Object.values(wrapSagaExports(UploadQuestionnaireSaga)),
      ...Object.values(wrapSagaExports(GetProspectSaga)),
      ...Object.values(wrapSagaExports(SearchMemberSaga)),
      ...Object.values(wrapSagaExports(GetVaultMemberSaga)),
      ...Object.values(wrapSagaExports(UpdateVaultMemberSaga)),
      ...Object.values(wrapSagaExports(UpdatePersonalSaga)),
      ...Object.values(wrapSagaExports(KycInviteSaga)),
      ...Object.values(wrapSagaExports(AccountSearchSaga)),
      ...Object.values(wrapSagaExports(AccountCreateSaga)),
      ...Object.values(wrapSagaExports(ApplicationSearchSaga)),
      ...Object.values(wrapSagaExports(FileListSaga)),
      ...Object.values(wrapSagaExports(FileUploadSaga)),
      ...Object.values(wrapSagaExports(FileManagementSaga)),
      ...Object.values(wrapSagaExports(GetVaultSaga)),
      ...Object.values(wrapSagaExports(UpdateVaultSaga)),
      ...Object.values(wrapSagaExports(GetApplicationNotesSaga)),
      ...Object.values(wrapSagaExports(UpdateApplicationNotesReviewSaga)),
      ...Object.values(wrapSagaExports(GetPaysafeDetailsSaga)),
      ...Object.values(wrapSagaExports(GetStaffListSaga)),
    ].map(fork)
  );
}
